import { BatchGetSpecObjectsForConversionsResponse } from '@fullstory/proto/fs/services/search-settings';
import { createRequestReducer } from '@fullstory/redux-util';
import { combineReducers } from 'redux';
import { ImpactTypes } from '../types';

const conversionsSpecSignals = createRequestReducer<BatchGetSpecObjectsForConversionsResponse>()(
  ImpactTypes.ListConversionsSpecSignalsRequest,
  ImpactTypes.ListConversionsSpecSignalsSuccess,
  ImpactTypes.ListConversionsSpecSignalsFailure,
);

type ImpactsSpecsState = {
  conversionsSpecSignals: ReturnType<typeof conversionsSpecSignals>;
};

export const conversionsSpec = combineReducers<ImpactsSpecsState>({
  conversionsSpecSignals,
});
